// Contexte partagé entre le shell Dashboard et les sous-pages extraites
// (ConfigPage, UsersPage, AlertsPage, etc.). Évite de prop-drill 6 niveaux
// de profondeur ou de tout garder en closures dans un seul fichier.

import { createContext, useContext } from 'react';

export const DashboardContext = createContext(null);

export function useDashboard() {
  const ctx = useContext(DashboardContext);
  if (!ctx) throw new Error('useDashboard() doit être appelé dans un <DashboardContext.Provider>');
  return ctx;
}
